import { render, staticRenderFns } from "./CategoriesSection.vue?vue&type=template&id=94fd24ce&scoped=true&"
import script from "./CategoriesSection.vue?vue&type=script&lang=js&"
export * from "./CategoriesSection.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesSection.vue?vue&type=style&index=0&id=94fd24ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fd24ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VBtn,VContainer,VSlideGroup,VSlideItem})
